module.exports = __webpack_public_path__ + "media/1.92a1f3ef.wav";